// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DiagnosisModels {
    static getAttributeTypeMap() {
        return DiagnosisModels.attributeTypeMap;
    }
}
DiagnosisModels.discriminator = undefined;
DiagnosisModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<DiagnosisModel>"
    }
];
//# sourceMappingURL=diagnosisModels.js.map